module.exports = __webpack_public_path__ + "img/main-logo.18f19519.png";